<template lang="pug">
  .board
    .board-header
      .unpin(v-if="item.un_pin_class === 2")
        i.fa.fa-star
      .private-lock(v-if="item.classes.private")
        i.fa.fa-lock
      .board-header-function(ref="boxPopover" v-if="$isMobile()" :class="[(keyActiveClass === 'itemClass_' + item.classes_id && isPopoverClass) ? 'open-popover' : '']" @click="clickPopoverClass('itemClass_' + item.classes_id, item.classes_id)")
        i.material-icons.text-gray(style="cursor:pointer") more_horiz
        .box-popover(:id="'popoverID_' + item.classes_id" ref="popoverID" :class="[keyActiveClass === 'itemClass_' + item.classes_id && (isSmart === 4 ? 'limit-right-bottom' : (isSmart === 1? 'limit-right' : (isSmart === 2) ? 'limit-bottom' : ''))]")
          span(v-if="item.status === 1" @click="onFlagDeleted(item)") Xoá yêu cầu
          span(v-if="item.status === 3" @click="onDeleted(item)") Xoá yêu cầu
          span(v-if="item.status === 2 && item.classes.private && item.un_pin_class === 1" @click="onDeleted(item, false)") Rời lớp học
          span(v-if="item.status === 2 && item.classes.private && item.un_pin_class === 2" @click="unPinPC(item, 1)") Bỏ ghim lớp học
          span(v-if="item.status === 2 && item.classes.private && item.un_pin_class === 2" @click="onDeleted(item, false)") Rời lớp học
          span(v-if="item.status === 2 && !item.classes.private && item.un_pin_class === 2" @click="copyLinkJoin(item)") Copy link tham gia
          span(v-if="item.status === 2 && !item.classes.private && item.un_pin_class === 2" @click="unPinPC(item, 1)") Bỏ ghim lớp học
          span(v-if="item.status === 2 && !item.classes.private && item.un_pin_class === 2" @click="onDeleted(item, false)") Rời lớp học
          span(v-if="item.status === 2 && !item.classes.private && item.un_pin_class === 1" @click="copyLinkJoin(item)") Copy link tham gia
          span(v-if="item.status === 2 && !item.classes.private && item.un_pin_class === 1" @click="unPinPC(item, 2)") Ghim lớp học
          span(v-if="item.status === 2 && !item.classes.private && item.un_pin_class === 1" @click="onDeleted(item, false)") Rời lớp học
      .board-header-function.and-hover(ref="boxPopover" @mouseleave="clickPopoverClass('itemClass_' + item.classes_id, item.classes_id)" v-else)
        i.material-icons.text-gray(style="cursor:pointer") more_horiz
        .box-popover(:id="'popoverID_' + item.classes_id" ref="popoverID" :class="[keyActiveClass === 'itemClass_' + item.classes_id && (isSmart === 4 ? 'limit-right-bottom' : (isSmart === 1? 'limit-right' : (isSmart === 2) ? 'limit-bottom' : ''))]")
          span(v-if="item.status === 1" @click="onFlagDeleted(item)") Xoá yêu cầu
          span(v-if="item.status === 3" @click="onDeleted(item)") Xoá yêu cầu
          span(v-if="item.status === 2 && item.classes.private && item.un_pin_class === 1" @click="onDeleted(item, false)") Rời lớp học
          span(v-if="item.status === 2 && item.classes.private && item.un_pin_class === 2" @click="unPinPC(item, 1)") Bỏ ghim lớp học
          span(v-if="item.status === 2 && item.classes.private && item.un_pin_class === 2" @click="onDeleted(item, false)") Rời lớp học
          span(v-if="item.status === 2 && !item.classes.private && item.un_pin_class === 2" @click="copyLinkJoin(item)") Copy link tham gia
          span(v-if="item.status === 2 && !item.classes.private && item.un_pin_class === 2" @click="unPinPC(item, 1)") Bỏ ghim lớp học
          span(v-if="item.status === 2 && !item.classes.private && item.un_pin_class === 2" @click="onDeleted(item, false)") Rời lớp học
          span(v-if="item.status === 2 && !item.classes.private && item.un_pin_class === 1" @click="copyLinkJoin(item)") Copy link tham gia
          span(v-if="item.status === 2 && !item.classes.private && item.un_pin_class === 1" @click="unPinPC(item, 2)") Ghim lớp học
          span(v-if="item.status === 2 && !item.classes.private && item.un_pin_class === 1" @click="onDeleted(item, false)") Rời lớp học
      .clearfix
    router-link(:to="{name: 'classes_to_me_detail', query: {id: item.classes_id}, params: {reload: 1}}")
      .board-img
        img(:src="item.classes.thumbnail" v-if="item.classes.thumbnail !== undefined  && item.classes.thumbnail !== null && item.classes.thumbnail.length > 0")
        img(src="../../assets/images/faces/ic_AvatarDefault@2x.png" v-else)
        .status-img(v-if="item.status === 1 || item.status === 3")
          span.approval(v-if="item.status === 1") Chờ duyệt
          span.cancel(v-else-if="item.status === 3") Bị từ chối
      .board-info
        .title-classes 
          span {{item.classes.name}}
</template>
<script>
import MdNotification from '@/core/components/mdNotification'
import moment from 'moment'
export default {
  components: {
    MdNotification
  },
  props: {
    item: Object,
    keyPopoverClass: {
      type: Boolean,
      default: false
    },
    keyActiveClass: '',
    keySmart: 0
  },
  data() {
    return {
      message: this.$t('home.comming_soon'),
      isPopoverClass: this.keyPopoverClass,
      isSmart: this.keySmart
    }
  },
  methods: {
    showNotification(message, color, from, align, timeout) {
      this.$notifications.notify({
        type: color,
        icon: 'notifications',
        message: message,
        placement: {
          from,
          align
        },
        timeout: timeout
      })
    },
    formatDate(value) {
      return moment(value).format('DD/MM/YYYY - hh:mm')
    },
    handerSmartPopover(classID) {
      var popoverHidden = document.querySelector('#popoverID_' + classID)
      popoverHidden.style.display = 'block'
      var element = document.getElementById('popoverID_' + classID)
      var width = element.clientWidth
      var height = element.clientHeight
      popoverHidden.style.display = 'none'
      var top = this.$refs.boxPopover.getBoundingClientRect().top
      var left = this.$refs.boxPopover.getBoundingClientRect().left
      let windowWidth = window.innerWidth
      let windowHeight = window.innerHeight
      this.isSmart = 0
      if ((left + width) > windowWidth && (top + height) > windowHeight) this.isSmart = 4
      else if ((left + width) > windowWidth) this.isSmart = 1
      else if ((top + height) > windowHeight) this.isSmart = 2
    },
    clickPopoverClass(itemActive, classID) {
      if (this.keyActiveClass !== '' && this.keyActiveClass !== itemActive) {
        this.isPopoverClass = true
      } else this.isPopoverClass = !this.isPopoverClass
      this.handerSmartPopover(classID)
      this.$emit('resetPopoverClass', itemActive, this.isPopoverClass, this.isSmart)
    },
    onFlagDeleted(item) {
      this.$emit('onFlagDeleted', item)
    },
    onDeleted(item, isDeleted = true) {
      this.$emit('onDeleted', item, isDeleted)
    },
    copyLinkJoin(item) {
      this.$emit('copyLinkJoin', item)
    },
    unPinPC(item, unPin) {
      this.$emit('onUnpinClass', item, unPin)
    }
  },
  apollo: {
  }
}
</script>

<style lang="scss">
  .item-classes-pc{
    .board{width: 148px; height: 148px;  cursor: pointer; padding: 5px 8px 15px; background: #FFFFFF url('../../assets/images/faces/bg_lop.png')  no-repeat padding-box center center; box-shadow: 0px 1px 2px #00000029;border-radius: 10px; display: block; margin: 0 auto;
      .board-header{
        .unpin{display: inline-block; margin-right: 4px;  position: relative; top:-4px;background: #FBF4D2 0% 0% no-repeat padding-box; border-radius: 20px; width: 16px; height: 16px; text-align: center;
          .fa{color: #9F6A28; font-size: 9px; display: block; line-height: 16px;}
        }
        .private-lock{background: #FBF4D2 0% 0% no-repeat padding-box; border-radius: 50%; width: 16px; height: 16px; display: inline-block; padding: 3px; position: relative; text-align: center; top: -4px;
          i{color: #4B2D15; font-size: 9px; display: block;}
        }
        .board-header-function{float: right; position: relative; cursor: pointer;
          .box-popover{position: absolute; top: 20px; left: 0; z-index: 1060; display: none; min-width: 150px; padding: 8px;  background: #F8F8F8 0% 0% no-repeat padding-box; box-shadow: 0px 1px 2px #00000029; border-radius: 10px;
            span{display: block; font-size: 15px; color: #23180A; padding: 5px;}
            &.limit-right{right: 0; left: auto;}
            &.limit-bottom{bottom: 30px; top: auto}
            &.limit-right-bottom{bottom: 30px; top: auto; right: 0; left: auto;}
          }
          &.open-popover{
            .box-popover{display: block;}
          }
          &.and-hover:hover{
            .box-popover{display: block;}
          }
        }
      }
      .board-img{width: 64px; height: 64px; margin: 0 auto; overflow: hidden; border-radius: 50%; display: flex; position: relative;
        img{max-width: 100%; height: auto; object-fit: cover;}
        .status-img{ position: absolute; opacity: 0.8; color: #fff; font-size: 8px; bottom: 0; width: 100%; text-align: center;
          .approval{background: #D63131 0% 0% no-repeat padding-box; display: block;}
          .cancel{background: #343A40 0% 0% no-repeat padding-box; display: block;}
        }
      }
      .board-info{ margin-top: 10px; max-height: 40px; overflow: hidden;
        .title-classes{color: #343A40; font-size: 15px; min-height: 40px; display: table; width: 100%; text-align: center; 
          span{display: table-cell; vertical-align: middle;}
        }
      }
    }
  }
@media screen and (max-width: 1366px){
  
}
@media screen and (max-width: 1024px){
  .item-classes-pc{ width: 25%;}
}
@media screen and (max-width: 991px){
  .item-classes-pc{ width: 25%;}
}
@media screen and (max-width: 768px){
}
@media screen and (max-width: 640px){
  .item-classes-pc{ width: 33.33%;}
}
@media screen and (max-width: 480px){
  .item-classes-pc{ width: 50%;}
}
</style>



// WEBPACK FOOTER //
// itemClasses.vue?3c40e893